import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnChanges, inject, model } from '@angular/core';

import { Observable } from 'rxjs';

import { FormComponent } from '@camelot/form-basic';
import { CamAbstractInput } from '@camelot/form-model';
import { ENotificationCode, LAZY_SERVICE_TOKEN } from '@camelot/notification';
import { ErrorComponent, LoaderComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { Template } from '../../../services/dto/template';
import { CamCommunicationsTemplateFormService } from '../../../services/form/template.service';
import { CamCommunicationsTemplatesService } from '../../../services/templates.service';
import { VariantEditComponent } from './variant-edit/variant-edit.component';

@Component({
  selector: 'cam-communication-template-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  imports: [CommonModule, LoaderComponent, ErrorComponent, FormComponent, VariantEditComponent],
})
export class CommunicationTemplateEditComponent extends CamBaseComponent implements OnChanges {
  id = model<string | null>(null);

  protected _notificationService = inject(LAZY_SERVICE_TOKEN);

  readonly communicationsTemplateFormService = inject(CamCommunicationsTemplateFormService);
  readonly communicationsTemplateService = inject(CamCommunicationsTemplatesService);

  public template$: Observable<Template> | null = null;
  public form: CamAbstractInput[] | null = null;

  ngOnChanges(): void {
    if (this.id()) {
      this._fetch();
    } else {
      this.setForm();
    }
  }

  public setForm(template?: Template) {
    this.form = this.communicationsTemplateFormService.getTemplateForm(template);
  }

  public createTemplate(data: any) {
    this.requestState.asked();
    const id = this.id();
    if (!id) {
      const template = this.communicationsTemplateFormService.formatTemplateForm(data);

      this.communicationsTemplateService.createTemplate$(template).subscribe({
        next: ({ id }) => {
          this.id.set(id);
          this._fetch();
        },
        complete: () => {
          this._notificationService.addNotification('notification.common.success', ENotificationCode.success);
          this.requestState.completed();
        },
        error: () => {
          this.requestState.completed();
        },
      });
    } else {
      const template = {
        ...this.communicationsTemplateFormService.formatTemplateForm(data),
        ...{ id },
      };

      this.communicationsTemplateService.updateTemplate$(template).subscribe({
        complete: () => {
          this._notificationService.addNotification('notification.common.success', ENotificationCode.success);
          this.requestState.completed();
        },
        error: () => {
          this.requestState.completed();
        },
      });
    }
  }

  private _fetch() {
    const id = this.id();
    if (!id) {
      return;
    }
    this.template$ = this.communicationsTemplateService.communicationTemplate.get$(id);

    this.requestState.asked();

    this.communicationsTemplateService.fetchConversationTemplate$(id).subscribe({
      next: template => {
        this.setForm(template);
      },
      complete: () => this.requestState.completed(),
      error: (error: HttpErrorResponse) => {
        this.requestState.onError(error.status, error.statusText);
      },
    });
  }
}
